import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';


@customElement('family-overview-page')
export class FamilyOverviewPage extends LitElement {

	static styles = css`
		:host {
			background-color: #fff;
			color: #000;
			margin-bottom: 20px;
			overflow: hidden;
			position: relative;
			box-sizing: border-box;
			page-break-after: always;
			//border: 1px solid black;
			//min-width: 210mm;
			//height: auto;

			width: 100%;
			// height: auto;
			//min-height: 297mm;
			display: flex;
			justify-content: start;
			flex-direction: column;
			aspect-ratio: 210/297;
			padding: 4cqw 5cqw 2cqw 5cqw;
		}

		@media print {
			:host {
				width: 210mm;
				height: 297mm;
				border: none;
				overflow: hidden;
				margin-bottom: 0;
			}
		}
	`;

	@property({headLabel: String})
	headLabel = 'Specsheet';

	render() {
		return html`
			<shared-specsheet-head headLabel="${this.headLabel}"></shared-specsheet-head>
			<slot></slot>
			<shared-specsheet-footer></shared-specsheet-footer>
		`;
	}
}
